import { render, staticRenderFns } from "./PaymentIndex.vue?vue&type=template&id=3ac2b0e7"
import script from "./PaymentIndex.vue?vue&type=script&lang=ts"
export * from "./PaymentIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports